import React from 'react';

import { useChartApi } from '~/hooks/use-chart-api/useChartApi';
import { ChartAreaProps } from '~/views/turbo-chart/components/chart-area/ChartArea';

import { ChartLegend } from './ChartLegend';

export const ChartArea = (props: ChartAreaProps) => {
  const { canvasRef, options, chartState, primaryAsset, primaryPane } = props;
  const chartApiRef = useChartApi({
    canvasRef,
    options,
    chartState,
    primaryAsset,
    primaryPane,
  });

  return (
    <>
      <canvas data-testid="chart-area-canvas" ref={canvasRef} />
      <ChartLegend {...props} chartApiRef={chartApiRef} />
    </>
  );
};
